import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DsButtonComponent } from "src/app/ui/design-system/button/button.component";

@Component({
  standalone: true,
  selector: "app-language",
  templateUrl: "./language.component.html",
  styleUrls: ["./language.component.scss"],
  imports: [DsButtonComponent, CommonModule]
})
export class LanguageComponent {
  @Input() style: string = "basic";

  public active: boolean = false;
  public languages: any[] = [
    {
      language: "English",
      code: "en",
      icon: "us"},
    {
      language: "Português",
      code: "pt",
      icon: "br"}];

  public selectedLanguage: any = {
    language: "Português",
    code: "pt",
    icon: "br"};

  constructor(private translate: TranslateService) {
    this.selectLanguage(this.selectedLanguage);
  }

  selectLanguage(language: any) {
    this.active = false;
    this.translate.use(language.code);
    this.selectedLanguage = language;
  }

  openDropDown() {
    this.active = !this.active;
  }

  hideDropdown() {
    this.active = false;
  }
}
